/**
 * Hvilken kladd som er åpen i denne fanen, per søknadstype (formType = url-en
 * i /soknadskjema/:formType). Ruta har ingen kladd-id, så uten dette mister
 * en refresh koblingen til kladden — og neste autolagring oppretter en ny.
 *
 * sessionStorage (ikke localStorage): to faner kan ha hver sin kladd av samme
 * type uten å tråkke på hverandre.
 */
const key = (formType: string) => `lyfti_active_draft_${formType}`;

export const readActiveDraft = (formType: string): number | null => {
    try {
        const raw = sessionStorage.getItem(key(formType));
        const id = raw ? Number(raw) : NaN;
        return Number.isFinite(id) && id > 0 ? id : null;
    } catch {
        return null;
    }
};

export const writeActiveDraft = (formType: string, id: number) => {
    try {
        sessionStorage.setItem(key(formType), String(id));
    } catch {
        /* privat modus o.l. — refresh mister da bare kladd-koblingen */
    }
};

/** Med `id`: fjern bare hvis det er nettopp denne kladden som er lagret. */
export const clearActiveDraft = (formType: string, id?: number) => {
    try {
        if (id !== undefined && readActiveDraft(formType) !== id) return;
        sessionStorage.removeItem(key(formType));
    } catch {
        /* ignore */
    }
};
